import React from 'react';
import {
  Container,
  Grid,
  makeStyles,
  Card,
  CardHeader,
  CardContent,
  Typography
} from '@material-ui/core';
import Page from 'src/components/Page';

import Tabelas from '../../shared/component/UIElements/Tabelas';
import Grafico from './components/grafico';
import Numeros from './components/numeros';
import Modificacoes from './components/modificacoes';
import Recentes from './components/recentes';
import Doadores from './components/doadores';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  },
  header: {
    border: '1px solid #ACACAC',
    borderTopLeftRadius: '4px',
    borderTopRightRadius: '4px',
    '& .MuiCardHeader-title': {
      fontSize: '20px',
      fontWeight: 700,
      fontFamily: 'Roboto',
      color: '#3E3E3E'
    }
  },
  container: {
    borderLeft: '1px solid #ACACAC',
    borderRight: '1px solid #ACACAC',
    borderBottom: '1px solid #ACACAC',
    borderBottomLeftRadius: '4px',
    borderBottomRightRadius: '4px',
    padding: '0px 0px 0px 0px',
    '&:last-child': {
      paddingBottom: 0
    }
  },
  box: {
    flexGrow: 1
  },
  numero: {
    fontSize: '45px',
    fontWeight: 500,
    color: '#3E3E3E',
    textAlign: 'center'
  },
  descricao: {
    fontSize: '21px',
    fontWeight: 700,
    color: '#808080',
    textAlign: 'center',
    maxWidth: '166px',
    lineHeight: '21px'
  },
  borda: {
    borderRight: '1px solid #ACACAC'
  },
  acessos: {
    marginTop: '18px'
  },
  titulo: {
    fontSize: '33px',
    fontWeight: 500,
    color: '#3E3E3E',
    textAlign: 'left'
  },
  topo: {
    margin: '25px 0px'
  },
  altura: {
    height: '100%'
  }
}));

const Relatorios = () => {
  const classes = useStyles();
  return (
    <Page
      className={classes.root}
      title="Relatórios"
    >
      <Container maxWidth="lg">
        <Grid
          container
          spacing={0}
          className={classes.topo}
        >
          <Grid
            item
            lg={12}
            md={12}
            xl={12}
            xs={12}
          >
            <Typography
              color="textPrimary"
              align="left"
              variant="h1"
              className={classes.titulo}
            >
              Relatórios
            </Typography>
          </Grid>
        </Grid>
        <Grid
          container
          spacing={3}
        >
          <Grid
            item
            lg={12}
            md={12}
            xl={12}
            xs={12}
          >
            <Numeros />
          </Grid>
        </Grid>
        <Grid
          className={classes.acessos}
          container
          spacing={3}
        >
          <Grid
            item
            lg={12}
            md={12}
            xl={12}
            xs={12}
          >
            <Card>
              <CardHeader
                title="Acessos ao site"
                className={classes.header}
              />
              <CardContent
                className={classes.container}
              >
                a
              </CardContent>
            </Card>
          </Grid>
        </Grid>
        <Grid
          className={classes.acessos}
          container
          spacing={3}
        >
          <Grid
            item
            lg={7}
            md={7}
            xl={7}
            xs={7}
          >
            <Card>
              <CardHeader
                title="Itens mais visualizados"
                className={classes.header}
              />
              <CardContent
                className={classes.container}
              >
                <Tabelas
                  data={[]}
                  minWidth="auto"
                  rowsPerPageOptions={[]}
                  limite={3}
                  estrutura={[
                    { id: 'destaque', tipo: 'avatar', nome: 'Foto' },
                    { id: 'nome', tipo: 'texto', nome: 'Item' },
                    { id: 'visualizacoes', tipo: 'texto', nome: 'Visualizações' },
                  ]}
                />
              </CardContent>
            </Card>
          </Grid>
          <Grid
            item
            lg={5}
            md={5}
            xl={5}
            xs={5}
          >
            <Modificacoes />
          </Grid>
        </Grid>
        <Grid
          className={classes.acessos}
          container
          spacing={3}
          direction="row"
          justifyContent="center"
          alignItems="center"
        >
          <Grid
            item
            lg={5}
            md={5}
            xl={5}
            xs={5}
          >
            <Grafico />
          </Grid>
          <Grid
            item
            lg={7}
            md={7}
            xl={7}
            xs={7}
          >
            <Doadores />
          </Grid>
        </Grid>
        <Grid
          className={classes.acessos}
          container
          spacing={3}
          direction="row"
          justifyContent="center"
          alignItems="center"
        >
          <Grid
            item
            lg={12}
            md={12}
            xl={12}
            xs={12}
          >
            <Recentes />
          </Grid>
        </Grid>
      </Container>
    </Page>
  );
};

export default Relatorios;
